<div fxLayout="row wrap">
  <div class="teranet-padding-relative" fxFlex="100">
    <ngx-spinner [fullScreen]="false"
                 type="ball-clip-rotate-multiple"
                 bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff"></ngx-spinner>
    <form [formGroup]="clientFormGroup" #createClientForm="ngForm" novalidate>
      <div class="mat-elevation-z4">
        <div fxFlex="100">
          <div fxLayout="column" fxLayoutAlign="center stretch">
            <Teranet-ClientTitle [ClientTitle]="'Client Information'" [IconName]="'university'"></Teranet-ClientTitle>
            <div fxLayout="row wrap">
              <div class="form-group-flex-column">
                <mat-label class="required-field-after">Corporation Code</mat-label>
                <mat-form-field appearance="outline">
                  <input matInput
                         id="corporationCode"
                         data-lpignore="true"
                         Name="txtcorporationcode"
                         autocomplete="off"
                         type="text"
                         formControlName="corporationCode"
                         required />
                  <mat-error *ngIf="clientFormGroup.get('corporationCode').hasError('required') || clientFormGroup.get('corporationCode').hasError('whitespace')">
                    Please Enter Corporation Code
                  </mat-error>
                </mat-form-field>
             </div>

              <div class="form-group-flex-column">
                <mat-label class="required-field-after">Corporation Name</mat-label>
                <mat-form-field appearance="outline">
                  <input matInput
                         type="text"
                         data-lpignore="true"
                         formControlName="corporationName"
                         required />
                  <mat-error *ngIf="clientFormGroup.get('corporationName').hasError('required') || clientFormGroup.get('corporationName').hasError('whitespace')">
                    Please Enter Corporation Name
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-group-flex-column">
                <mat-label class="required-field-after">Corporation Type</mat-label>
                <mat-form-field appearance="outline">
                  <mat-select required
                              placeholder="--Please Select--"
                              formControlName="corporationType">
                    <mat-option *ngFor="let ci of clientTypes" [value]="ci" >
                      {{ci}}
                    </mat-option>
                  </mat-select>

                  <mat-error *ngIf="clientFormGroup.get('corporationType').hasError('required') || clientFormGroup.get('corporationType').hasError('whitespace')">
                    Please Enter Corporation Type
                  </mat-error>
                </mat-form-field>
              </div>
            
          </div>

          <div fxLayout="row wrap">
            <div class="form-group-flex-column">
              <mat-checkbox formControlName="isEnabled">Is Enabled</mat-checkbox>
            </div>
          </div>

          <div *ngIf="!this.Readonly" fxLayout="row wrap" fxLayoutAlign="end center" fxFlex="100">
            <button mat-raised-button class="plain-button-lg" type="button" (click)="goToClient()">Cancel</button>
            <button mat-raised-button class="theme-button-lg" type="submit" (click)="createClient()">Save</button>
          </div>
        </div>
        </div>
      </div>
    </form>
  </div>
</div>
